import React, { useState, useEffect } from 'react';
import { NumberOnlyRegex } from 'utils/commonValidations';
import commonService from 'utils/commonService';

/**
* @description1 <input/> 限制輸入為純數字 0~9
* @description2 一般使用 <InputNumber/>
* @description2 可搭配 formik 使用 <Field component={InputNumber} name="xxx"  />
* @param <input/> props and formik form、field props
*/
const InputWithRegex = ({ field, form, regex, thousandFormat, autoWidth, innerRef, ...props }: any) => {
  const [valueState, setValueState] = useState('');
  const [validRegex, setValidRegex] = useState(regex);

  useEffect(() => {
    let regVal = NumberOnlyRegex;

    if (regex) {
      regVal = regex;
    }

    setValidRegex(regVal);
  }, [regex]);

  // autoWidth 為 true 初始化欄位寬度為 0
  useEffect(() => {
    if (autoWidth && innerRef && innerRef.current) {
      handleFieldWidthAuto(innerRef, 0);
    }
  }, [autoWidth, innerRef, valueState]);

  useEffect(() => {
    setValueState(field.value || '');
  }, [field.value]);

  // autoWidth 為 true 設定欄位寬度根據字元長度調整
  useEffect(() => {
    if (autoWidth && innerRef && innerRef.current && valueState) {
      handleFieldWidthAuto(innerRef, valueState.length);
    }
  }, [autoWidth, innerRef, valueState]);

  const handleInputchange = (e: any) => {
    // 去除千分位符號
    const value = commonService.removeComma(e.target.value);

    /** 限制輸入值為 0~9 */
    if (validRegex.test(value) && form) {
      /** 如套用formik ,觸發 form change 事件，帶動 form 綁定的驗證 */
      form.handleChange(e);

      /** 判斷是否需要千分位格式化 */
      const val = thousandFormat ? commonService.thousandFormat(value) : value;

      /** 更新state value */
      setValueState(val);

      if (props.onChange) {
        props.onChange(val);
      }
    }
  };

  /**
   * @description 根據內容寬度設置 Field 寬度
   */
  const handleFieldWidthAuto = (fieldRef: React.RefObject<HTMLInputElement>, fieldValueLength: number) => {
    if (fieldRef && fieldRef.current) {
      fieldRef.current.style.width = `calc(${fieldValueLength}ch + 22px)`;
    }
  };

  return (
    <input type="text" ref={innerRef} {...props} {...field} value={valueState} onBlur={props.onBlur} onChange={handleInputchange} />
  );
};

export default InputWithRegex;
